// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SuggestionBubbles.css */
.suggestion-bubbles {
    display: flex;
    gap: 10px;
    padding: 10px 20px;
    background-color: var(--background-color);
    justify-content: center;
  }
  
  .suggestion-bubble {
    padding: 5px 9px;
    background-color: var(--assistant-message-background);
    color: var(--text-color);
    border: none;
    border-radius: 17px;
    cursor: pointer;
    font-size: 11px;
    transition: background-color 0.3s;
  }
  
  .suggestion-bubble:hover {
    background-color: var(--hover-background-color);
    color: var(--hover-text-color);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/styles/SuggestionBubbles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,qDAAqD;IACrD,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,+CAA+C;IAC/C,8BAA8B;EAChC","sourcesContent":["/* SuggestionBubbles.css */\r\n.suggestion-bubbles {\r\n    display: flex;\r\n    gap: 10px;\r\n    padding: 10px 20px;\r\n    background-color: var(--background-color);\r\n    justify-content: center;\r\n  }\r\n  \r\n  .suggestion-bubble {\r\n    padding: 5px 9px;\r\n    background-color: var(--assistant-message-background);\r\n    color: var(--text-color);\r\n    border: none;\r\n    border-radius: 17px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .suggestion-bubble:hover {\r\n    background-color: var(--hover-background-color);\r\n    color: var(--hover-text-color);\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
